import contract from '@mailobj-browser/front/js/contracts/contract.js'
import hotkeys from './hotkeys/hotkeys.js'

export default contract({
  hotkeys
})